import './CSVUploader.css';
import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Vector as VectorSource } from 'ol/source';
import Papa from 'papaparse';
import { vectorForCSV as vector } from '../../../../_config/layers';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';

function CSVUploader(props) {
  const { t } = useTranslation();
  const htmlElement = useRef();
  const feedbackElement = useRef();
  const [data, setData] = useState(undefined);

  const handleChange = (e) => {
    const files = e.target.files;
    if (files) {
      Papa.parse(files[0], {
        complete: function (results) {
          setData(results.data);
        }
      });
    }
  };

  const convertCSVToFeatures = () => {
    try {
      if (!data) return showErrorFeedback();

      const latitudeColumn = getLatitudeColumn(data[0]);
      const longitudeColumn = getLongitudeColumn(data[0]);

      if (
        latitudeColumn === undefined ||
        longitudeColumn === undefined ||
        data.length < 2
      )
        return showErrorFeedback();

      vector.setSource(new VectorSource());

      data.forEach((element, index) => {
        if (index > 0) {
          const feature = generateFeature(data[0], element, longitudeColumn, latitudeColumn);
          vector.getSource().addFeature(feature);
        }
      });

      props.map.getView().fit(vector.getSource().getExtent(), props.map.getSize());
      props.callback();
    } catch (error) {
      console.error(error);
      showErrorFeedback();
    }
  };

  const getLatitudeColumn = (keys) =>
    keys.findIndex((el) => ['lat', 'lati', 'latitude', 'Latitude'].includes(el));

  const getLongitudeColumn = (keys) =>
    keys.findIndex((el) => ['lng', 'long', 'longitude', 'Longitude'].includes(el));

  const generateFeature = (keys, values, longIdx, latIdx) => {
    const obj = mergeKeysAndValues(keys, values);
    return new Feature({
      geometry: new Point([parseFloat(values[longIdx]), parseFloat(values[latIdx])]),
      ...obj
    });
  };

  const mergeKeysAndValues = (keys, values) =>
    keys.reduce((obj, key, index) => ({ ...obj, [key]: values[index] }), {});

  const handleReset = () => {
    vector.getSource().clear();
  };

  const showErrorFeedback = () => {
    feedbackElement.current.style.visibility = 'visible';
  };

  useEffect(convertCSVToFeatures, [data]);
  useEffect(() => {
    feedbackElement.current.style.visibility = 'hidden';
  }, []);

  return (
    <div className="CSVUploader">
      <h6>
        <label htmlFor="csvFormFile" className="form-label">
          {t('csvUploader.label')}
        </label>
      </h6>

      <div className="input-group mb-3">
        <input
          ref={htmlElement}
          className="form-control"
          id="csvFormFile"
          type="file"
          accept=".csv,.xlsx,.xls"
          onChange={handleChange}
          style={{borderRadius: '10px 0px 0px 10px'}}
        />
        <span onClick={handleReset} className="input-group-text CSVUploaderReset">
          {t('csvUploader.reset')}
        </span>
      </div>

      <div className="CSVUploaderHint">
        {t('csvUploader.hint')}
        <p>
          <a href="/portal/template.csv" download rel="noreferrer">
            {t('csvUploader.templateLink')}
          </a>
        </p>
      </div>

      <div ref={feedbackElement} className="CSVUploaderErrorFeedback">
        {t('csvUploader.error')}
      </div>
    </div>
  );
}

export default CSVUploader;
